"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 3H2v15h5l-1 1v2h12v-2l-1-1h5zm-2 13H4V5h16z"
}), 'MonitorSharp');